import { get, post } from '../fetch'

export const login = (payload) => {
  return post(`auth/login`, payload)
}

export const refresh = (payload) => {
  return post(`auth/refresh`, payload)
}

export const getReferrer = (key) => {
  return get(`auth/referrer?key=${key}`)
}
